import "./Login.css";
import HeaderImage from "./img/loginLogo.png";
import Title from "../../component/title/Title";
import TextInput from "../../component/textInput/TextInput";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import asiamobiliti from "./img/asiamobiliti.png";
import {
  PrimaryButton,
  TextButton,
} from "../../component/buttonComponent/ButtonComponent";
import SnackBar from "../../component/Snackbar/Snackbar";
import Text from "../../component/text/Text";
import Checkbox from "../../component/checkbox/Checkbox";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../../firebase";
import { APIGetAdministratorByFirebaseToken } from "../../config/utilities/APIs";

export default function Login() {
  const [input, setInput] = useState({
    email: "",
    password: "",
    extendValidity: "",
  });

  const [emailError, setEmailError] = useState(false);
  const [emailErrorMessage, setEmailErrorMessage] = useState("");
  const [passwordError, setPasswordError] = useState(false);
  const [passwordErrorMessage, setPasswordErrorMessage] = useState("");
  const [keyUp, setKeyUp] = useState("", false);
  const [loading, setLoading] = useState(false);

  const [snackBarState, setSnackBarState] = useState(false);
  const [snackBarConfig, setSnackBarConfig] = useState({
    title: "",
    subtitle: "",
    module: "",
    action: ",",
  });
  const navigate = useNavigate();

  const emailOnChangeFunction = (e) => {
    setInput({ ...input, email: e.target.value });
  };

  const passwordOnChangeFunction = (e) => {
    setInput({ ...input, password: e.target.value });
  };

  const btnForgot = (e) => {
    e.preventDefault();
    navigate("/forgotpassword", { replace: true });
  };

  const isValidEmail = (email) => {
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return regex.test(email);
  };

  const btnLogin = async (e) => {
    e.preventDefault();

    if (!input.email || !input.password) {
      setEmailError(!input.email);
      setPasswordError(!input.password);
      setEmailErrorMessage(input.email ? "" : "Email address is required");
      setPasswordErrorMessage(input.password ? "" : "Password is required");
      return;
    }

    if (!isValidEmail(input.email)) {
      setEmailError(true);
      setEmailErrorMessage("Invalid email address.");
      return;
    }

    try {
      setLoading(true);

      const userCredential = await signInWithEmailAndPassword(
        auth,
        input.email,
        input.password
      );

      const user = userCredential.user;
      const token = await user.getIdToken(true);

      // Fetch admin details (includes email verification status)
      const adminDetails = await APIGetAdministratorByFirebaseToken(
        token,
        setLoading
      );

      if (!adminDetails?.emailVerification?.isVerified) {
        navigate("/unverifieduser");
        return;
      } else if (
        adminDetails.privileges?.some((p) => p.role === "SUPERADMIN") ||
        (Array.isArray(adminDetails.privileges) &&
          adminDetails.privileges.length > 1)
      ) {
        navigate("/institutionselector");
      } else {
        navigate("/dashboard");
      }
    } catch (error) {
      let errorMessage = "An error occurred. Please try again.";

      if (error.code === "auth/invalid-credential") {
        errorMessage = "Your email and/or password is incorrect";
      }

      setSnackBarConfig({
        title: "Login Failed",
        subtitle: errorMessage,
        module: "Login",
        action: "error",
      });
      setSnackBarState(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div
        className="login-roww"
      >
        <div className="login-column">
          <div className="login-container-main">
            <div className="login-section">
              <div className="login-container">
                <div className="login-contents">
                  <div className="login-logo">
                    <img
                      loading="lazy"
                      src={HeaderImage}
                      className="logo"
                      alt="header-logo"
                    />
                  </div>

                  <div className="login-header-form">
                    <div className="login-header">
                      <Title
                        title="Log in"
                        subtitle="Welcome back! Please enter your details."
                        titleSize="1.75rem"
                        subtitleSize="0.875rem"
                        gap="0.75rem"
                      />
                    </div>
                    <form
                      className="login-content-form"
                      onSubmit={btnLogin}
                      noValidate
                    >
                      <div className="login-form">
                        <div className="login-input-container">
                          <TextInput
                            width="100%"
                            label="Email"
                            placeholder="Enter email"
                            setInput={setInput}
                            input={input}
                            name="email"
                            type="text"
                            error={emailError}
                            errorMessage={emailErrorMessage}
                            setError={setEmailError}
                            keyUp={keyUp}
                            setKeyUp={setKeyUp}
                            onChangeFunction={emailOnChangeFunction}
                          />
                        </div>
                        <div className="login-input-container">
                          <TextInput
                            width="100%"
                            label="Password"
                            placeholder="Enter password"
                            setInput={setInput}
                            input={input}
                            name="password"
                            type="password"
                            error={passwordError}
                            setError={setPasswordError}
                            keyUp={keyUp}
                            setKeyUp={setKeyUp}
                            onChangeFunction={passwordOnChangeFunction}
                            errorMessage="Password is required"
                          />
                        </div>
                      </div>
                      <div className="login-row">
                        <div className="login-checkbox">
                          <div className="login-checkbox-label">
                            <Checkbox
                              className="login-checkbox-input"
                              checked={input.extendValidity}
                              onChange={(e) =>
                                setInput((prev) => ({
                                  ...prev,
                                  extendValidity: e.target.checked,
                                }))
                              }
                              text=""
                              width="16px"
                              height="16px"
                              borderRadius="4px"
                            />

                            <Text
                              className="login-checkbox-label-text"
                              text="Remember for 30 days"
                              size="0.875rem"
                              color="#344054"
                              weight="500"
                              align="left"
                            />
                          </div>
                        </div>
                        <div className="forgot-password-button">
                          <TextButton
                            label="Forgot password"
                            onClickFunction={btnForgot}
                          />
                        </div>
                      </div>
                      <div className="login-action">
                        <PrimaryButton
                          label="Log in"
                          width="100%"
                          buttonType="submit"
                          loading={loading}
                        />
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="login-footer">
            <Title
              subtitle="Copyright © 2025 Asia Mobility Technologies. All Rights Reserved."
              titleSize="0.875rem"
              subtitleSize="0.875rem"
              gap="0rem"
            />
          </div>
        </div>
        <div className="image-login-section">
          <div className="just-login-quote">
            <div className="login-quote-container">
              <div className="login-quote">
                All-in-one smart admin console for real-time tracking, route
                management, scheduling, and notifications.
              </div>
              <div className="text-and-stars">
                <div className="powered-by" style={{ gap: "0rem" }}>
                  <Title
                    title=""
                    subtitle="Powered by"
                    titleSize="0rem"
                    subtitleSize="1rem"
                    gap="0rem"
                  />
                  <img
                    src={asiamobiliti}
                    loading="lazy"
                    alt="Asia Mobiliti logo"
                    style={{
                      height: "1rem",
                      paddingTop: "0.2rem",
                      paddingLeft: "0.2rem",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {snackBarState && (
        <div className="notification">
          <SnackBar
            state={snackBarState}
            setState={setSnackBarState}
            title={snackBarConfig.title}
            subtitle={snackBarConfig.subtitle}
            module={snackBarConfig.module}
            action={snackBarConfig.action}
          />
        </div>
      )}
    </>
  );
}
